<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="openAdd" style="margin-top: 20px">上传凭证</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="3" style="margin-top:20px" v-for="(item, index) in tableData" :key="index">
        <el-card :body-style="{ padding: '0px' }" style="margin-left:10px">
          <img :src="item.FILE_URL" class="image" style="height:200px" v-if="item.FILE_TYPE === 1">
          <img :src="pdfImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else-if="item.FILE_TYPE === 2">
          <img :src="wordImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else-if="item.FILE_TYPE === 3">
          <img :src="unknowImage" class="image" style="height:180px;width: 80%;margin-left:8%;margin-top:20px" v-else>
          <div style="padding: 14px;">
            <div class="bottom clearfix">
              <el-button size="medium" type="text" class="button" @click="openImage(item.FILE_URL)" v-if="item.FILE_TYPE === 1">查看大图</el-button>
              <el-button size="medium" type="text" class="button" @click="downLoad(item.FILE_URL)" v-else>下载</el-button>
              <el-button size="medium" type="text" class="button" @click="previewFile(item.FILE_URL)" v-if="item.FILE_TYPE === 2">预览</el-button>
              <el-button size="medium" type="text" class="button" style="float:right" @click="deleteImg(item.ID)">删除</el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <img :src="this.imgUrl" style="width:100%">
    </el-dialog>
    <el-row>
      <el-col>
        <el-dialog :visible.sync="addFormDialog" title="上传资质凭证" @close="close" width="400px" center>
          <el-form ref="addForm" v-model="addForm">
            <el-upload class="upload-demo" action="/uploadFile" ref="upload" :on-success="handleSuccess" :before-upload="onBeforeUpload"
              :on-remove="handleRemove" :name="this.addForm.image" :multiple="false" :file-list="fileList" :limit="1">
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form>
          <div slot="footer" style="text-align: center;">
            <el-button @click="viewfile" v-show="fileType">预览</el-button>
            <el-button class="operate-btn" @click="close">取消</el-button>
            <el-button class="operate-btn" @click="submitAdd">确认</el-button>
          </div>
        </el-dialog>
        <el-dialog :visible.sync="pdfPreviewDialog" title="资质凭证" width="50%" center>
          <pdf :src="src" v-for="i in numPages" :key="i" :page="i" style="width:100%" ref="pdf"></pdf>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import pdf from 'vue-pdf';
import http from '@/assets/common/http';

export default {
  components: {
    pdf,
  },
  data() {
    return {
      tableData: [],
      addFormDialog: false,
      addForm: {
        image: 'SupplierQualify',
      },
      fileList: [],
      url: '',
      dialogVisible: false,
      imgUrl: '',
      pdfImage: require('@/assets/common/image/pdf.png'),
      wordImage: require('@/assets/common/image/word.png'),
      unknowImage: require('@/assets/common/image/unknow.png'),
      fileData: '',
      pdfUrl: '',
      pdfSrc: '',
      src: '',
      numPages: null, // pdf 总页数
      pdfPreviewDialog: false,
      fileType: false,
    };
  },
  methods: {
    queryContract() {
      const data = {
        SERVICE_ID: '10002',
        OTYPE: 7,
        QUALIFY_ID: sessionStorage.getItem('licenseId'),
      };
      http.post(data).then((result) => {
        this.tableData = result;
      }).catch((error) => {
        this.$message.show({
          text: error,
          type: 'error',
        });
      });
    },
    deleteImg(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10002',
            OTYPE: 3,
            FILE_ID: row,
          };
          http.post(data).then((result) => {
            this.$message.show({ text: '删除成功', type: 'success' });
            this.queryContract();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            document.body.style.cursor = 'default';
          });
        } finally {}
      }
    },
    openAdd() {
      this.addFormDialog = true;
    },
    openImage(e) {
      this.dialogVisible = true;
      this.imgUrl = e;
    },
    downLoad(e) {
      window.location.href = e;
    },
    handleSuccess(response, file, fileList) {
      this.url = response.base_url + response.file_name;
    },
    handleRemove(file, fileList) {
      this.url = '';
      this.fileData = '';
      this.fileType = false;
    },
    // 上传格式做限制
    onBeforeUpload(file) {
      this.file = file;
      this.fileName = file.name;
      const extension = file.name.split('.').slice(-1) == 'pdf';
      if (extension) {
        this.fileType = true;
      }
      const reader = new FileReader();
      reader.readAsDataURL(file);
      const that = this;
      reader.onload = function () {
        that.fileData = reader.result;
      };
    },
    // 预览文件
    viewfile() {
      if (!this.fileData) {
        this.$message.show({ text: '请先上传文件!', type: 'warning' });
        return;
      }
      const win = window.open();
      win.document.write(
        `<body style="margin:0px;"><object data="${
          this.fileData
        }" type="application/pdf" width="100%" height="100%"><iframe src="${
          this.fileData
        }" scrolling="no" width="100%" height="100%" frameborder="0" ></iframe></object></body>`,
      );
    },
    previewFile(file) {
      window.open(`https://service.linkda.com.cn/pdf/web/viewer.html?file=${file}`);
    },
    //  计算pdf页码总数
    getNumPages() {
      const loadingTask = this.src;
      loadingTask.promise.then((Pdf) => {
        this.numPages = Pdf.numPages;
      }).catch((err) => {
        // eslint-disable-next-line no-console
        console.error('pdf 加载失败', err);
      });
    },
    close() {
      this.addFormDialog = false;
      this.fileList = [];
      this.fileData = '';
      this.fileType = false;
    },
    handleClose() {
      this.dialogVisible = false;
    },
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else if (this.url) {
        document.body.style.cursor = 'wait';
        try {
          const data = {
            SERVICE_ID: '10002',
            OTYPE: 2,
            QUALIFY_ID: sessionStorage.getItem('licenseId'),
            FILE_URL: this.url,
          };
          http.post(data).then((result) => {
            this.$message.show({ text: '新增成功', type: 'success' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.queryContract();
            this.close();
            document.body.style.cursor = 'default';
          }).catch((error) => {
            this.$message.show({ text: error, type: 'error' });
            this.url = '';
            this.$refs.upload.clearFiles();
            this.fileType = false;
            document.body.style.cursor = 'default';
          });
        } finally {}
      } else {
        this.$message.show({ text: '请选择凭证进行上传', type: 'warning' });
      }
    },
  },
  created() {
    this.queryContract();
  },
};
</script>
<style>
.image {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/supplierManage/uploadLicense.vue